import React from 'react';

import { Errors } from 'utils';

type Props = {
  errors: Errors;
};

const InputErrors = ({ errors }: Props) => {
  const wrappedErrors = errors.map((error, key) => {
    return (
      <div className="small form-text text-danger text-center" key={key}>
        {error}
      </div>
    );
  });
  return <div className="inputErrors">{wrappedErrors}</div>;
};

export default InputErrors;
